import * as _ from "lodash";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { BoundsHelperService } from "../map/bounds.helper";
import { MarkerService } from "../map/marker.helper";
import { Division } from "../../models/division.model";
import { Organisation } from "../../models/organisation.model";
import { DivisionDataProvider } from "../../data-provider/division.dp";

let DivisionMapComponent = {
    selector: "vcDivisionMap",
    templateUrl: "/angular/components/division/division-map.component.html",
    bindings: {},
    controller: class DivisionMapController {
        private readonly $scope: any;
        private readonly __env: any;

        private gmapApi: any;
        private gmapIsReady: any;
        private dataProvider: DivisionDataProvider;
        private campaignDataProvider: CampaignDataProvider;
        private boundsHelperService: BoundsHelperService;
        private markerService: MarkerService;
        private activeOrganisation: Organisation;
        private hasBoundsChanged = false;
        private divisions: Array<Division>;

        public gmap: any;
        public map: any;
        public mapEvents: object;
        public markerEvents: object;
        public loading = true;
        public markers = [];

        constructor(
            $scope: any,
            __env: any,
            uiGmapGoogleMapApi: any,
            uiGmapIsReady: any,
            DivisionDataProvider: DivisionDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            BoundsHelperService: BoundsHelperService,
            MarkerService: MarkerService
        ) {
            this.$scope = $scope;
            this.__env = __env;
            this.dataProvider = DivisionDataProvider;
            this.campaignDataProvider = CampaignDataProvider;
            this.gmapApi = uiGmapGoogleMapApi;
            this.gmapIsReady = uiGmapIsReady;
            this.boundsHelperService = BoundsHelperService;
            this.markerService = MarkerService;

            this.dataProvider
                .getAllDivisions()
                .then((divisions: Array<Division>) => {
                    this.divisions = divisions;
                });

            this.mapEvents = {
                bounds_changed: this.boundsChanged,
            };

            this.markerEvents = {
                click: (event: any) => {
                    angular.forEach(this.markers, (marker: any) => {
                        marker.show =
                            marker.divisionid === event.model.divisionid;
                    });
                },
            };
        }

        $onInit() {
            this.$scope.$watch(
                () => this.divisions,
                (
                    newValue: Division[] | undefined,
                    oldValue: Division[] | undefined
                ) => {
                    if (newValue && oldValue && newValue != oldValue) {
                        this.loadMarkers();
                    }
                },
                true
            );
        }

        initMap(): void {
            this.campaignDataProvider
                .getOrganisations()
                .then((organisation: Organisation) => {
                    this.activeOrganisation = organisation;
                    this.activeOrganisation.getLocalStorage();

                    if (this.activeOrganisation.localInfo.divsionMap) {
                        this.loadMap(
                            this.activeOrganisation.localInfo.divsionMap.center,
                            this.activeOrganisation.localInfo.divsionMap.zoom
                        );
                    } else {
                        this.loadMap({ latitude: 30, longitude: 10 }, 3);
                    }
                });
        }

        loadMap(
            center: { latitude: number; longitude: number },
            zoom: number
        ): void {
            this.gmapApi.then(() => {
                if (!zoom) zoom = 12;
                this.map = {
                    center: center,
                    control: {},
                    zoom: zoom,
                    bounds: {},
                };

                this.gmapIsReady.promise().then(() => {
                    this.gmap = this.map.control.getGMap();
                    this.gmap.setOptions(this.boundsHelperService.getOptions());
                    this.loadMarkers();
                });
            });
        }

        loadMarkers(): void {
            this.dataProvider
                .getAllDivisions()
                .then((divisions: Array<Division>) => {
                    this.divisions = divisions;

                    let i = 0;
                    angular.forEach(this.divisions, (division: Division) => {
                        if (division.divisionid && division.stats.houses > 0) {
                            let marker = _.cloneDeep(division) as any;
                            marker.id = i + 10000;
                            marker.size = marker.stats.houses;
                            marker.voters = this.__env.strings.voters;
                            marker.coords = {
                                latitude: marker.lat,
                                longitude: marker.long,
                            };
                            marker.options =
                                this.markerService.getMarkerOption(marker);
                            marker.show = false;
                            this.markers.push(marker);
                            i++;
                        }
                    });

                    this.loading = false;
                });
        }

        boundsChanged(): void {
            this.hasBoundsChanged = true;
        }

        setMapCenter(): void {
            if (this.hasBoundsChanged) {
                this.activeOrganisation.localInfo.divsionMap = {
                    center: this.map.center,
                    zoom: this.map.zoom,
                };
                this.activeOrganisation.saveLocalStorage();
            }
        }
    },
};

angular
    .module("division")
    .component(DivisionMapComponent.selector, DivisionMapComponent);
